import React,{useEffect} from "react";

const EditableSummaryField = ({
  selectedtranscriptjson,
  setSelectedTranscriptJson,
  field,
  label,
  rows = 3,
}) => {
  const value = selectedtranscriptjson?.summaryMap?.[field] || "Not Required";

  useEffect(() => {
    // Ensure that the field exists in the summaryMap when the component mounts
    if (!selectedtranscriptjson?.summaryMap?.hasOwnProperty(field)) { 
         setSelectedTranscriptJson((prev) => ({
          ...prev,
          summaryMap: {
            ...prev.summaryMap,
            [field]: 'Not Required',
          },
        }));
    }
  }, [field, selectedtranscriptjson]);

  const handleChange = (e) => {
    const newValue = e.target.value;

    setSelectedTranscriptJson((prev) => ({
      ...prev,
      summaryMap: {
        ...prev.summaryMap,
        [field]: newValue,
      },
    }));
  };

  return (
    <div className="summary-field">
      {/* {label && <label className="summary-field-label">{label}</label>} */}

      <textarea
        value={value}
        onChange={handleChange}
        rows="3"
        className="assessment-textarea"
      />
    </div>
  );
};

export default EditableSummaryField;